/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Logo, Page, Group, Copy, Title, BodyCopy, CTAs, Button } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/auth/expiredlink/expiredlink_styles';



/* ========== ~~~~~~~~~~ AUTH EXPIRED LINK ~~~~~~~~~~ ========== */
class ExpiredLinkPage extends Component{
    handleLinkClick = () => {
        this.props.resendInvite(this.props.tokenData.userUUID, true, 'auth/newinvitationsent')
    };
    render(){
        return (
            <Page name={`expiredlink`} klass={this.props.classes.expiredlink}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <Logo/>
                        </Title>
                        <BodyCopy>
                            <h3>Your invitation has expired.</h3>
                            <p className={'invitationcopy'}>The invitation link you followed expired. Please generate a new link to signup:</p>
                            <CTAs>
                                <Button variant={'primary'} type={'action'} action={this.handleLinkClick} text={'Send a new link to your email'} />
                            </CTAs>
                        </BodyCopy>
                    </Copy>
                </Group>
            </Page>)
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ExpiredLinkPage);
